<template>
<div>
<CourseGrading/>

</div>
</template>
<script>
import CourseGrading from "../../components/academic/CourseGrading.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   CourseGrading
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>